import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";

const DataTableFooter = ({ dataT }) => {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center py-3">
      {/* Showing Entries Section */}
      <div className="mb-2 mb-md-0">
        Showing 1 to {dataT.length} of {dataT.length} entries
      </div>

      {/* Pagination Section */}
      <div className="dataTables_paginate paging_simple_numbers" id="timetracker-table_paginate">
        <ul className="pagination mb-0">
          {/* Previous Button */}
          <li className="paginate_button page-item previous disabled" id="timetracker-table_previous">
            <Link
              href="#"
              aria-controls="timetracker-table"
              data-dt-idx="0"
              tabIndex="0"
              className="page-link"
            >
              Previous
            </Link>
          </li>

          {/* Page Number */}
          <li className="paginate_button page-item active">
            <Link
              href="#"
              aria-controls="timetracker-table"
              data-dt-idx="1"
              tabIndex="0"
              className="page-link text-white bg-primary"
            >
              1
            </Link>
          </li>

          {/* Next Button */}
          <li className="paginate_button page-item next disabled" id="timetracker-table_next">
            <Link
              href="#"
              aria-controls="timetracker-table"
              data-dt-idx="2"
              tabIndex="0"
              className="page-link"
            >
              Next
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DataTableFooter;
